module.exports = __webpack_public_path__ + "static/media/296225.ffe88738.png";